export const countriesInfosAndCurrencyMock$: CountryInfosAndCurrencyModel[] = [
    {
        id: 1,
        code: 4,
        alpha2: 'AF',
        alpha3: 'AFG',
        english_name: 'Afghanistan',
        french_name: 'Afghanistan',
        call_sign: 93,
        currency_name_en: 'Afghani',
        currency_name_fr: 'afghani afghan',
        currency_name_plural_fr: 'afghanis afghan',
        currency_code: 'AFN',
        currency_symbol_native: '؋',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 2,
        code: 8,
        alpha2: 'AL',
        alpha3: 'ALB',
        english_name: 'Albania',
        french_name: 'Albanie',
        call_sign: 335,
        currency_name_en: 'Lek',
        currency_name_fr: 'lek albanais',
        currency_name_plural_fr: 'leks albanais',
        currency_code: 'ALL',
        currency_symbol_native: 'Lekë',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    /*
    {
        id: 3,
        code: 10,
        alpha2: 'AQ',
        alpha3: 'ATA',
        english_name: 'Antarctica',
        french_name: 'Antarctique',
        call_sign: 672,
        currency_name_en: 'Antarctican dollar',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'AQD',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },*/
    {
        id: 4,
        code: 12,
        alpha2: 'DZ',
        alpha3: 'DZA',
        english_name: 'Algeria',
        french_name: 'Algérie',
        call_sign: 213,
        currency_name_en: 'Algerian Dinar',
        currency_name_fr: 'dinar algérien',
        currency_name_plural_fr: 'dinars algériens',
        currency_code: 'DZD',
        currency_symbol_native: 'د.ج.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 5,
        code: 16,
        alpha2: 'AS',
        alpha3: 'ASM',
        english_name: 'American Samoa',
        french_name: 'Samoa Américaines',
        call_sign: 1684,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 6,
        code: 20,
        alpha2: 'AD',
        alpha3: 'AND',
        english_name: 'Andorra',
        french_name: 'Andorre',
        call_sign: 376,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 7,
        code: 24,
        alpha2: 'AO',
        alpha3: 'AGO',
        english_name: 'Angola',
        french_name: 'Angola',
        call_sign: 244,
        currency_name_en: 'Angolan kwanza',
        currency_name_fr: 'kwanza angolais',
        currency_name_plural_fr: 'kwanzas angolais',
        currency_code: 'AOA',
        currency_symbol_native: 'Kz',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 8,
        code: 28,
        alpha2: 'AG',
        alpha3: 'ATG',
        english_name: 'Antigua and Barbuda',
        french_name: 'Antigua-et-Barbuda',
        call_sign: 1268,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 9,
        code: 31,
        alpha2: 'AZ',
        alpha3: 'AZE',
        english_name: 'Azerbaijan',
        french_name: 'Azerbaïdjan',
        call_sign: 994,
        currency_name_en: 'Manat',
        currency_name_fr: 'manat azéri',
        currency_name_plural_fr: 'manats azéris',
        currency_code: 'AZN',
        currency_symbol_native: '₼',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 10,
        code: 32,
        alpha2: 'AR',
        alpha3: 'ARG',
        english_name: 'Argentina',
        french_name: 'Argentine',
        call_sign: 54,
        currency_name_en: 'Peso',
        currency_name_fr: 'peso argentin',
        currency_name_plural_fr: 'pesos argentins',
        currency_code: 'ARS',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 11,
        code: 36,
        alpha2: 'AU',
        alpha3: 'AUS',
        english_name: 'Australia',
        french_name: 'Australie',
        call_sign: 61,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 12,
        code: 40,
        alpha2: 'AT',
        alpha3: 'AUT',
        english_name: 'Austria',
        french_name: 'Autriche',
        call_sign: 43,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 13,
        code: 44,
        alpha2: 'BS',
        alpha3: 'BHS',
        english_name: 'Bahamas',
        french_name: 'Bahamas',
        call_sign: 1242,
        currency_name_en: 'Bahamian Dollar',
        currency_name_fr: 'dollar bahaméen',
        currency_name_plural_fr: 'dollars bahaméens',
        currency_code: 'BSD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 14,
        code: 48,
        alpha2: 'BH',
        alpha3: 'BHR',
        english_name: 'Bahrain',
        french_name: 'Bahreïn',
        call_sign: 973,
        currency_name_en: 'Bahraini Dinar',
        currency_name_fr: 'dinar bahreïni',
        currency_name_plural_fr: 'dinars bahreïnis',
        currency_code: 'BHD',
        currency_symbol_native: 'د.ب.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 15,
        code: 50,
        alpha2: 'BD',
        alpha3: 'BGD',
        english_name: 'Bangladesh',
        french_name: 'Bangladesh',
        call_sign: 880,
        currency_name_en: 'Taka',
        currency_name_fr: 'taka bangladeshi',
        currency_name_plural_fr: 'takas bangladeshis',
        currency_code: 'BDT',
        currency_symbol_native: '৳',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 16,
        code: 51,
        alpha2: 'AM',
        alpha3: 'ARM',
        english_name: 'Armenia',
        french_name: 'Arménie',
        call_sign: 374,
        currency_name_en: 'Dram',
        currency_name_fr: 'dram arménien',
        currency_name_plural_fr: 'drams arméniens',
        currency_code: 'AMD',
        currency_symbol_native: '֏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 17,
        code: 52,
        alpha2: 'BB',
        alpha3: 'BRB',
        english_name: 'Barbados',
        french_name: 'Barbade',
        call_sign: 1246,
        currency_name_en: 'Barbadian Dollar',
        currency_name_fr: 'dollar barbadien',
        currency_name_plural_fr: 'dollars barbadiens',
        currency_code: 'BBD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 18,
        code: 56,
        alpha2: 'BE',
        alpha3: 'BEL',
        english_name: 'Belgium',
        french_name: 'Belgique',
        call_sign: 32,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 19,
        code: 60,
        alpha2: 'BM',
        alpha3: 'BMU',
        english_name: 'Bermuda',
        french_name: 'Bermudes',
        call_sign: 1441,
        currency_name_en: 'Bermudian Dollar',
        currency_name_fr: 'dollar bermudien',
        currency_name_plural_fr: 'dollars bermudiens',
        currency_code: 'BMD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 20,
        code: 64,
        alpha2: 'BT',
        alpha3: 'BTN',
        english_name: 'Bhutan',
        french_name: 'Bhoutan',
        call_sign: 975,
        currency_name_en: 'Indian Rupee',
        currency_name_fr: 'roupie indienne',
        currency_name_plural_fr: 'roupies indiennes',
        currency_code: 'INR',
        currency_symbol_native: '₹',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 21,
        code: 68,
        alpha2: 'BO',
        alpha3: 'BOL',
        english_name: 'Bolivia',
        french_name: 'Bolivie',
        call_sign: 591,
        currency_name_en: 'Boliviano',
        currency_name_fr: 'boliviano bolivien',
        currency_name_plural_fr: 'bolivianos boliviens',
        currency_code: 'BOB',
        currency_symbol_native: 'Bs',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 22,
        code: 70,
        alpha2: 'BA',
        alpha3: 'BIH',
        english_name: 'Bosnia and Herzegovina',
        french_name: 'Bosnie-Herzégovine',
        call_sign: 387,
        currency_name_en: 'Bosnia and Herzegovina convertible mark',
        currency_name_fr: 'mark convertible bosniaque',
        currency_name_plural_fr: 'marks convertibles bosniaques',
        currency_code: 'BAM',
        currency_symbol_native: 'КМ',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 23,
        code: 72,
        alpha2: 'BW',
        alpha3: 'BWA',
        english_name: 'Botswana',
        french_name: 'Botswana',
        call_sign: 267,
        currency_name_en: 'Pula',
        currency_name_fr: 'pula botswanais',
        currency_name_plural_fr: 'pulas botswanais',
        currency_code: 'BWP',
        currency_symbol_native: 'P',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    /*
    {
        id: 24,
        code: 74,
        alpha2: 'BV',
        alpha3: 'BVT',
        english_name: 'Bouvet Island',
        french_name: 'Île Bouvet',
        call_sign: 47,
        currency_name_en: 'Norwegian Krone',
        currency_name_fr: 'couronne norvégienne',
        currency_name_plural_fr: 'couronnes norvégiennes',
        currency_code: 'NOK',
        currency_symbol_native: 'kr',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },*/
    {
        id: 25,
        code: 76,
        alpha2: 'BR',
        alpha3: 'BRA',
        english_name: 'Brazil',
        french_name: 'Brésil',
        call_sign: 55,
        currency_name_en: 'Brazil',
        currency_name_fr: 'réal brésilien',
        currency_name_plural_fr: 'réals brésiliens',
        currency_code: 'BRL',
        currency_symbol_native: 'R$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 26,
        code: 84,
        alpha2: 'BZ',
        alpha3: 'BLZ',
        english_name: 'Belize',
        french_name: 'Belize',
        call_sign: 501,
        currency_name_en: 'Belizean Dollar',
        currency_name_fr: 'dollar bélizéen',
        currency_name_plural_fr: 'dollars bélizéens',
        currency_code: 'BZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 27,
        code: 86,
        alpha2: 'IO',
        alpha3: 'IOT',
        english_name: 'British Indian Ocean Territory',
        french_name: 'Territoire Britannique de l\'Océan Indien',
        call_sign: 246,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 28,
        code: 90,
        alpha2: 'SB',
        alpha3: 'SLB',
        english_name: 'Solomon Islands',
        french_name: 'Îles Salomon',
        call_sign: 677,
        currency_name_en: 'Solomon Islands Dollar',
        currency_name_fr: 'dollar des îles Salomon',
        currency_name_plural_fr: 'dollars des îles Salomon',
        currency_code: 'SBD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 29,
        code: 92,
        alpha2: 'VG',
        alpha3: 'VGB',
        english_name: 'British Virgin Islands',
        french_name: 'Îles Vierges Britanniques',
        call_sign: 1284,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 30,
        code: 96,
        alpha2: 'BN',
        alpha3: 'BRN',
        english_name: 'Brunei Darussalam',
        french_name: 'Brunéi Darussalam',
        call_sign: 673,
        currency_name_en: 'Bruneian Dollar',
        currency_name_fr: 'dollar brunéien',
        currency_name_plural_fr: 'dollars brunéiens',
        currency_code: 'BND',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 31,
        code: 100,
        alpha2: 'BG',
        alpha3: 'BGR',
        english_name: 'Bulgaria',
        french_name: 'Bulgarie',
        call_sign: 359,
        currency_name_en: 'Lev',
        currency_name_fr: 'lev bulgare',
        currency_name_plural_fr: 'levs bulgares',
        currency_code: 'BGN',
        currency_symbol_native: 'лв.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 32,
        code: 104,
        alpha2: 'MM',
        alpha3: 'MMR',
        english_name: 'Myanmar',
        french_name: 'Myanmar',
        call_sign: 95,
        currency_name_en: 'Kyat',
        currency_name_fr: 'kyat myanmarais',
        currency_name_plural_fr: 'kyats myanmarais',
        currency_code: 'MMK',
        currency_symbol_native: 'K',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 33,
        code: 108,
        alpha2: 'BI',
        alpha3: 'BDI',
        english_name: 'Burundi',
        french_name: 'Burundi',
        call_sign: 257,
        currency_name_en: 'Burundi Franc',
        currency_name_fr: 'franc burundais',
        currency_name_plural_fr: 'francs burundais',
        currency_code: 'BIF',
        currency_symbol_native: 'FBu',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 34,
        code: 112,
        alpha2: 'BY',
        alpha3: 'BLR',
        english_name: 'Belarus',
        french_name: 'Biélorussie',
        call_sign: 375,
        currency_name_en: 'Belarus Ruble',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'BYR',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 35,
        code: 116,
        alpha2: 'KH',
        alpha3: 'KHM',
        english_name: 'Cambodia',
        french_name: 'Cambodge',
        call_sign: 855,
        currency_name_en: 'Riel',
        currency_name_fr: 'riel cambodgien',
        currency_name_plural_fr: 'riels cambodgiens',
        currency_code: 'KHR',
        currency_symbol_native: '៛',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 36,
        code: 120,
        alpha2: 'CM',
        alpha3: 'CMR',
        english_name: 'Cameroon',
        french_name: 'Cameroun',
        call_sign: 237,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    /*
    {
        id: 37,
        code: 124,
        alpha2: 'CA',
        alpha3: 'CAN',
        english_name: 'Canada',
        french_name: 'Canada',
        call_sign: 1,
        currency_name_en: 'Canadian Dollar',
        currency_name_fr: 'dollar canadien',
        currency_name_plural_fr: 'dollars canadiens',
        currency_code: 'CAD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },*/
    {
        id: 38,
        code: 132,
        alpha2: 'CV',
        alpha3: 'CPV',
        english_name: 'Cape Verde',
        french_name: 'Cap-vert',
        call_sign: 238,
        currency_name_en: 'Escudo',
        currency_name_fr: 'escudo capverdien',
        currency_name_plural_fr: 'escudos capverdiens',
        currency_code: 'CVE',
        currency_symbol_native: '​',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 39,
        code: 136,
        alpha2: 'KY',
        alpha3: 'CYM',
        english_name: 'Cayman Islands',
        french_name: 'Îles Caïmanes',
        call_sign: 1345,
        currency_name_en: 'Caymanian Dollar',
        currency_name_fr: 'dollar des îles Caïmans',
        currency_name_plural_fr: 'dollars des îles Caïmans',
        currency_code: 'KYD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 40,
        code: 140,
        alpha2: 'CF',
        alpha3: 'CAF',
        english_name: 'Central African',
        french_name: 'République Centrafricaine',
        call_sign: 236,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 41,
        code: 144,
        alpha2: 'LK',
        alpha3: 'LKA',
        english_name: 'Sri Lanka',
        french_name: 'Sri Lanka',
        call_sign: 94,
        currency_name_en: 'Rupee',
        currency_name_fr: 'roupie srilankaise',
        currency_name_plural_fr: 'roupies srilankaises',
        currency_code: 'LKR',
        currency_symbol_native: 'රු.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 42,
        code: 148,
        alpha2: 'TD',
        alpha3: 'TCD',
        english_name: 'Chad',
        french_name: 'Tchad',
        call_sign: 235,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 43,
        code: 152,
        alpha2: 'CL',
        alpha3: 'CHL',
        english_name: 'Chile',
        french_name: 'Chili',
        call_sign: 56,
        currency_name_en: 'Chilean Peso',
        currency_name_fr: 'peso chilien',
        currency_name_plural_fr: 'pesos chiliens',
        currency_code: 'CLP',
        currency_symbol_native: '$',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 44,
        code: 156,
        alpha2: 'CN',
        alpha3: 'CHN',
        english_name: 'China',
        french_name: 'Chine',
        call_sign: 86,
        currency_name_en: 'Yuan Renminbi',
        currency_name_fr: 'yuan renminbi chinois',
        currency_name_plural_fr: 'yuans renminbi chinois',
        currency_code: 'CNY',
        currency_symbol_native: '¥',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 45,
        code: 158,
        alpha2: 'TW',
        alpha3: 'TWN',
        english_name: 'Taiwan',
        french_name: 'Taïwan',
        call_sign: 886,
        currency_name_en: 'Dollar',
        currency_name_fr: 'nouveau dollar taïwanais',
        currency_name_plural_fr: 'nouveaux dollars taïwanais',
        currency_code: 'TWD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 46,
        code: 162,
        alpha2: 'CX',
        alpha3: 'CXR',
        english_name: 'Christmas Island',
        french_name: 'Île Christmas',
        call_sign: 672,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 47,
        code: 166,
        alpha2: 'CC',
        alpha3: 'CCK',
        english_name: 'Cocos (Keeling) Islands',
        french_name: 'Îles Cocos (Keeling)',
        call_sign: 672,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 48,
        code: 170,
        alpha2: 'CO',
        alpha3: 'COL',
        english_name: 'Colombia',
        french_name: 'Colombie',
        call_sign: 57,
        currency_name_en: 'Peso',
        currency_name_fr: 'peso colombien',
        currency_name_plural_fr: 'pesos colombiens',
        currency_code: 'COP',
        currency_symbol_native: '$',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 49,
        code: 174,
        alpha2: 'KM',
        alpha3: 'COM',
        english_name: 'Comoros',
        french_name: 'Comores',
        call_sign: 269,
        currency_name_en: 'Comoran Franc',
        currency_name_fr: 'franc comorien',
        currency_name_plural_fr: 'francs comoriens',
        currency_code: 'KMF',
        currency_symbol_native: 'CF',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 50,
        code: 175,
        alpha2: 'YT',
        alpha3: 'MYT',
        english_name: 'Mayotte',
        french_name: 'Mayotte',
        call_sign: 262,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 51,
        code: 178,
        alpha2: 'CG',
        alpha3: 'COG',
        english_name: 'Republic of the Congo',
        french_name: 'République du Congo',
        call_sign: 242,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 52,
        code: 180,
        alpha2: 'CD',
        alpha3: 'COD',
        english_name: 'The Democratic Republic Of The Congo',
        french_name: 'République Démocratique du Congo',
        call_sign: 243,
        currency_name_en: 'Congolese Frank',
        currency_name_fr: 'franc congolais',
        currency_name_plural_fr: 'francs congolais',
        currency_code: 'CDF',
        currency_symbol_native: 'FC',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 53,
        code: 184,
        alpha2: 'CK',
        alpha3: 'COK',
        english_name: 'Cook Islands',
        french_name: 'Îles Cook',
        call_sign: 682,
        currency_name_en: 'New Zealand Dollars',
        currency_name_fr: 'dollar néo-zélandais',
        currency_name_plural_fr: 'dollars néo-zélandais',
        currency_code: 'NZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 54,
        code: 188,
        alpha2: 'CR',
        alpha3: 'CRI',
        english_name: 'Costa Rica',
        french_name: 'Costa Rica',
        call_sign: 506,
        currency_name_en: 'Costa Rican Colon',
        currency_name_fr: 'colón costaricain',
        currency_name_plural_fr: 'colóns costaricains',
        currency_code: 'CRC',
        currency_symbol_native: '₡',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 55,
        code: 191,
        alpha2: 'HR',
        alpha3: 'HRV',
        english_name: 'Croatia',
        french_name: 'Croatie',
        call_sign: 385,
        currency_name_en: 'Croatian Dinar',
        currency_name_fr: 'kuna croate',
        currency_name_plural_fr: 'kunas croates',
        currency_code: 'HRK',
        currency_symbol_native: 'HRK',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 56,
        code: 192,
        alpha2: 'CU',
        alpha3: 'CUB',
        english_name: 'Cuba',
        french_name: 'Cuba',
        call_sign: 53,
        currency_name_en: 'Cuban Peso',
        currency_name_fr: 'peso cubain',
        currency_name_plural_fr: 'pesos cubains',
        currency_code: 'CUP',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 57,
        code: 196,
        alpha2: 'CY',
        alpha3: 'CYP',
        english_name: 'Cyprus',
        french_name: 'Chypre',
        call_sign: 357,
        currency_name_en: 'Cypriot Pound',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'CYP',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 58,
        code: 203,
        alpha2: 'CZ',
        alpha3: 'CZE',
        english_name: 'Czech Republic',
        french_name: 'République Tchèque',
        call_sign: 420,
        currency_name_en: 'Koruna',
        currency_name_fr: 'couronne tchèque',
        currency_name_plural_fr: 'couronnes tchèques',
        currency_code: 'CZK',
        currency_symbol_native: 'Kč',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 59,
        code: 204,
        alpha2: 'BJ',
        alpha3: 'BEN',
        english_name: 'Benin',
        french_name: 'Bénin',
        call_sign: 229,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 60,
        code: 208,
        alpha2: 'DK',
        alpha3: 'DNK',
        english_name: 'Denmark',
        french_name: 'Danemark',
        call_sign: 45,
        currency_name_en: 'Danish Krone',
        currency_name_fr: 'couronne danoise',
        currency_name_plural_fr: 'couronnes danoises',
        currency_code: 'DKK',
        currency_symbol_native: 'kr.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 61,
        code: 212,
        alpha2: 'DM',
        alpha3: 'DMA',
        english_name: 'Dominica',
        french_name: 'Dominique',
        call_sign: 1767,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    /*
    {
        id: 62,
        code: 214,
        alpha2: 'DO',
        alpha3: 'DOM',
        english_name: 'Dominican Republic',
        french_name: 'République Dominicaine',
        call_sign: 1,
        currency_name_en: 'Dominican Peso',
        currency_name_fr: 'peso dominicain',
        currency_name_plural_fr: 'pesos dominicains',
        currency_code: 'DOP',
        currency_symbol_native: 'RD$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },*/
    {
        id: 63,
        code: 218,
        alpha2: 'EC',
        alpha3: 'ECU',
        english_name: 'Ecuador',
        french_name: 'Équateur',
        call_sign: 593,
        currency_name_en: 'Sucre',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'ECS',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 64,
        code: 222,
        alpha2: 'SV',
        alpha3: 'SLV',
        english_name: 'El Salvador',
        french_name: 'El Salvador',
        call_sign: 503,
        currency_name_en: 'Salvadoran Colon',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'SVC',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 65,
        code: 226,
        alpha2: 'GQ',
        alpha3: 'GNQ',
        english_name: 'Equatorial Guinea',
        french_name: 'Guinée Équatoriale',
        call_sign: 240,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 66,
        code: 231,
        alpha2: 'ET',
        alpha3: 'ETH',
        english_name: 'Ethiopia',
        french_name: 'Éthiopie',
        call_sign: 251,
        currency_name_en: 'Ethiopian Birr',
        currency_name_fr: 'birr éthiopien',
        currency_name_plural_fr: 'birrs éthiopiens',
        currency_code: 'ETB',
        currency_symbol_native: 'ብር',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 67,
        code: 232,
        alpha2: 'ER',
        alpha3: 'ERI',
        english_name: 'Eritrea',
        french_name: 'Érythrée',
        call_sign: 291,
        currency_name_en: 'Ethiopian Birr',
        currency_name_fr: 'birr éthiopien',
        currency_name_plural_fr: 'birrs éthiopiens',
        currency_code: 'ETB',
        currency_symbol_native: 'ብር',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 68,
        code: 233,
        alpha2: 'EE',
        alpha3: 'EST',
        english_name: 'Estonia',
        french_name: 'Estonie',
        call_sign: 372,
        currency_name_en: 'Estonian Kroon',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'EEK',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 69,
        code: 234,
        alpha2: 'FO',
        alpha3: 'FRO',
        english_name: 'Faroe Islands',
        french_name: 'Îles Féroé',
        call_sign: 298,
        currency_name_en: 'Danish Krone',
        currency_name_fr: 'couronne danoise',
        currency_name_plural_fr: 'couronnes danoises',
        currency_code: 'DKK',
        currency_symbol_native: 'kr.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 70,
        code: 238,
        alpha2: 'FK',
        alpha3: 'FLK',
        english_name: 'Falkland Islands',
        french_name: 'Îles (malvinas) Falkland',
        call_sign: 500,
        currency_name_en: 'Falkland Pound',
        currency_name_fr: 'livre des îles Malouines',
        currency_name_plural_fr: 'livres des îles Malouines',
        currency_code: 'FKP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 71,
        code: 239,
        alpha2: 'GS',
        alpha3: 'SGS',
        english_name: 'South Georgia and the South Sandwich Islands',
        french_name: 'Géorgie du Sud et les Îles Sandwich du Sud',
        call_sign: 500,
        currency_name_en: 'Sterling',
        currency_name_fr: 'livre sterling',
        currency_name_plural_fr: 'livres sterling',
        currency_code: 'GBP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 72,
        code: 242,
        alpha2: 'FJ',
        alpha3: 'FJI',
        english_name: 'Fiji',
        french_name: 'Fidji',
        call_sign: 679,
        currency_name_en: 'Fijian Dollar',
        currency_name_fr: 'dollar fidjien',
        currency_name_plural_fr: 'dollars fidjiens',
        currency_code: 'FJD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 73,
        code: 246,
        alpha2: 'FI',
        alpha3: 'FIN',
        english_name: 'Finland',
        french_name: 'Finlande',
        call_sign: 358,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 74,
        code: 248,
        alpha2: 'AX',
        alpha3: 'ALA',
        english_name: 'Åland Islands',
        french_name: 'Åland',
        call_sign: 358,
        currency_name_en: 'Euro',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 75,
        code: 250,
        alpha2: 'FR',
        alpha3: 'FRA',
        english_name: 'France',
        french_name: 'France',
        call_sign: 33,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 76,
        code: 254,
        alpha2: 'GF',
        alpha3: 'GUF',
        english_name: 'French Guiana',
        french_name: 'Guyane Française',
        call_sign: 594,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 77,
        code: 258,
        alpha2: 'PF',
        alpha3: 'PYF',
        english_name: 'French Polynesia',
        french_name: 'Polynésie Française',
        call_sign: 689,
        currency_name_en: 'CFP Franc',
        currency_name_fr: 'franc CFP',
        currency_name_plural_fr: 'francs CFP',
        currency_code: 'XPF',
        currency_symbol_native: 'FCFP',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    /*
    {
        id: 78,
        code: 260,
        alpha2: 'TF',
        alpha3: 'ATF',
        english_name: 'French Southern Territories',
        french_name: 'Terres Australes Françaises',
        call_sign: 262,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    }, */
    {
        id: 79,
        code: 262,
        alpha2: 'DJ',
        alpha3: 'DJI',
        english_name: 'Djibouti',
        french_name: 'Djibouti',
        call_sign: 253,
        currency_name_en: 'Djiboutian Franc',
        currency_name_fr: 'franc djiboutien',
        currency_name_plural_fr: 'francs djiboutiens',
        currency_code: 'DJF',
        currency_symbol_native: 'Fdj',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 80,
        code: 266,
        alpha2: 'GA',
        alpha3: 'GAB',
        english_name: 'Gabon',
        french_name: 'Gabon',
        call_sign: 241,
        currency_name_en: 'CFA Franc BEAC',
        currency_name_fr: 'franc CFA (BEAC)',
        currency_name_plural_fr: 'francs CFA (BEAC)',
        currency_code: 'XAF',
        currency_symbol_native: 'FCFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 81,
        code: 268,
        alpha2: 'GE',
        alpha3: 'GEO',
        english_name: 'Georgia',
        french_name: 'Géorgie',
        call_sign: 995,
        currency_name_en: 'Lari',
        currency_name_fr: 'lari géorgien',
        currency_name_plural_fr: 'lari géorgiens',
        currency_code: 'GEL',
        currency_symbol_native: '₾',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 82,
        code: 270,
        alpha2: 'GM',
        alpha3: 'GMB',
        english_name: 'Gambia',
        french_name: 'Gambie',
        call_sign: 220,
        currency_name_en: 'Dalasi',
        currency_name_fr: 'dalasi gambien',
        currency_name_plural_fr: 'dalasis gambiens',
        currency_code: 'GMD',
        currency_symbol_native: 'D',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 83,
        code: 275,
        alpha2: 'PS',
        alpha3: 'PSE',
        english_name: 'Occupied Palestinian Territory',
        french_name: 'Territoire Palestinien Occupé',
        call_sign: 970,
        currency_name_en: 'Jordanian dinar',
        currency_name_fr: 'dinar jordanien',
        currency_name_plural_fr: 'dinars jordaniens',
        currency_code: 'JOD',
        currency_symbol_native: 'د.أ.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 84,
        code: 276,
        alpha2: 'DE',
        alpha3: 'DEU',
        english_name: 'Germany',
        french_name: 'Allemagne',
        call_sign: 49,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 85,
        code: 288,
        alpha2: 'GH',
        alpha3: 'GHA',
        english_name: 'Ghana',
        french_name: 'Ghana',
        call_sign: 233,
        currency_name_en: 'Ghana cedi',
        currency_name_fr: 'cédi ghanéen',
        currency_name_plural_fr: 'cédis ghanéens',
        currency_code: 'GHS',
        currency_symbol_native: 'GH₵',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 86,
        code: 292,
        alpha2: 'GI',
        alpha3: 'GIB',
        english_name: 'Gibraltar',
        french_name: 'Gibraltar',
        call_sign: 350,
        currency_name_en: 'Gibraltar Pound',
        currency_name_fr: 'livre de Gibraltar',
        currency_name_plural_fr: 'livres de Gibraltar',
        currency_code: 'GIP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 87,
        code: 296,
        alpha2: 'KI',
        alpha3: 'KIR',
        english_name: 'Kiribati',
        french_name: 'Kiribati',
        call_sign: 686,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 88,
        code: 300,
        alpha2: 'GR',
        alpha3: 'GRC',
        english_name: 'Greece',
        french_name: 'Grèce',
        call_sign: 30,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 89,
        code: 304,
        alpha2: 'GL',
        alpha3: 'GRL',
        english_name: 'Greenland',
        french_name: 'Groenland',
        call_sign: 299,
        currency_name_en: 'Danish Krone',
        currency_name_fr: 'couronne danoise',
        currency_name_plural_fr: 'couronnes danoises',
        currency_code: 'DKK',
        currency_symbol_native: 'kr.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 90,
        code: 308,
        alpha2: 'GD',
        alpha3: 'GRD',
        english_name: 'Grenada',
        french_name: 'Grenade',
        call_sign: 1473,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 91,
        code: 312,
        alpha2: 'GP',
        alpha3: 'GLP',
        english_name: 'Guadeloupe',
        french_name: 'Guadeloupe',
        call_sign: 590,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 92,
        code: 316,
        alpha2: 'GU',
        alpha3: 'GUM',
        english_name: 'Guam',
        french_name: 'Guam',
        call_sign: 1671,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 93,
        code: 320,
        alpha2: 'GT',
        alpha3: 'GTM',
        english_name: 'Guatemala',
        french_name: 'Guatemala',
        call_sign: 502,
        currency_name_en: 'Quetzal',
        currency_name_fr: 'quetzal guatémaltèque',
        currency_name_plural_fr: 'quetzals guatémaltèques',
        currency_code: 'GTQ',
        currency_symbol_native: 'Q',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 94,
        code: 324,
        alpha2: 'GN',
        alpha3: 'GIN',
        english_name: 'Guinea',
        french_name: 'Guinée',
        call_sign: 224,
        currency_name_en: 'Guinean Franc',
        currency_name_fr: 'franc guinéen',
        currency_name_plural_fr: 'francs guinéens',
        currency_code: 'GNF',
        currency_symbol_native: 'FG',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 95,
        code: 328,
        alpha2: 'GY',
        alpha3: 'GUY',
        english_name: 'Guyana',
        french_name: 'Guyana',
        call_sign: 592,
        currency_name_en: 'Guyanaese Dollar',
        currency_name_fr: 'dollar du Guyana',
        currency_name_plural_fr: 'dollars du Guyana',
        currency_code: 'GYD',
        currency_symbol_native: '$',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 96,
        code: 332,
        alpha2: 'HT',
        alpha3: 'HTI',
        english_name: 'Haiti',
        french_name: 'Haïti',
        call_sign: 509,
        currency_name_en: 'Gourde',
        currency_name_fr: 'gourde haïtienne',
        currency_name_plural_fr: 'gourdes haïtiennes',
        currency_code: 'HTG',
        currency_symbol_native: 'G',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 97,
        code: 334,
        alpha2: 'HM',
        alpha3: 'HMD',
        english_name: 'Heard Island and McDonald Islands',
        french_name: 'Îles Heard et Mcdonald',
        call_sign: 672,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 98,
        code: 336,
        alpha2: 'VA',
        alpha3: 'VAT',
        english_name: 'Vatican City State',
        french_name: 'Saint-Siège (état de la Cité du Vatican)',
        call_sign: 379,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 99,
        code: 340,
        alpha2: 'HN',
        alpha3: 'HND',
        english_name: 'Honduras',
        french_name: 'Honduras',
        call_sign: 504,
        currency_name_en: 'Lempira',
        currency_name_fr: 'lempira hondurien',
        currency_name_plural_fr: 'lempiras honduriens',
        currency_code: 'HNL',
        currency_symbol_native: 'L',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 100,
        code: 344,
        alpha2: 'HK',
        alpha3: 'HKG',
        english_name: 'Hong Kong',
        french_name: 'Hong-Kong',
        call_sign: 852,
        currency_name_en: 'HKD',
        currency_name_fr: 'dollar de Hong Kong',
        currency_name_plural_fr: 'dollars de Hong Kong',
        currency_code: 'HKD',
        currency_symbol_native: 'HK$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 101,
        code: 348,
        alpha2: 'HU',
        alpha3: 'HUN',
        english_name: 'Hungary',
        french_name: 'Hongrie',
        call_sign: 36,
        currency_name_en: 'Forint',
        currency_name_fr: 'forint hongrois',
        currency_name_plural_fr: 'forints hongrois',
        currency_code: 'HUF',
        currency_symbol_native: 'Ft',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 102,
        code: 352,
        alpha2: 'IS',
        alpha3: 'ISL',
        english_name: 'Iceland',
        french_name: 'Islande',
        call_sign: 354,
        currency_name_en: 'Icelandic Krona',
        currency_name_fr: 'couronne islandaise',
        currency_name_plural_fr: 'couronnes islandaises',
        currency_code: 'ISK',
        currency_symbol_native: 'ISK',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 103,
        code: 356,
        alpha2: 'IN',
        alpha3: 'IND',
        english_name: 'India',
        french_name: 'Inde',
        call_sign: 91,
        currency_name_en: 'Indian Rupee',
        currency_name_fr: 'roupie indienne',
        currency_name_plural_fr: 'roupies indiennes',
        currency_code: 'INR',
        currency_symbol_native: '₹',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 104,
        code: 360,
        alpha2: 'ID',
        alpha3: 'IDN',
        english_name: 'Indonesia',
        french_name: 'Indonésie',
        call_sign: 62,
        currency_name_en: 'Indonesian Rupiah',
        currency_name_fr: 'roupie indonésienne',
        currency_name_plural_fr: 'roupies indonésiennes',
        currency_code: 'IDR',
        currency_symbol_native: 'Rp',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 105,
        code: 364,
        alpha2: 'IR',
        alpha3: 'IRN',
        english_name: 'Islamic Republic of Iran',
        french_name: 'République Islamique d\'Iran',
        call_sign: 98,
        currency_name_en: 'Iranian Rial',
        currency_name_fr: 'riyal iranien',
        currency_name_plural_fr: 'riyals iraniens',
        currency_code: 'IRR',
        currency_symbol_native: 'IRR',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 106,
        code: 368,
        alpha2: 'IQ',
        alpha3: 'IRQ',
        english_name: 'Iraq',
        french_name: 'Iraq',
        call_sign: 964,
        currency_name_en: 'Iraqi Dinar',
        currency_name_fr: 'dinar irakien',
        currency_name_plural_fr: 'dinars irakiens',
        currency_code: 'IQD',
        currency_symbol_native: 'د.ع.‏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 107,
        code: 372,
        alpha2: 'IE',
        alpha3: 'IRL',
        english_name: 'Ireland',
        french_name: 'Irlande',
        call_sign: 353,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 108,
        code: 376,
        alpha2: 'IL',
        alpha3: 'ISR',
        english_name: 'Israel',
        french_name: 'Israël',
        call_sign: 972,
        currency_name_en: 'Shekel',
        currency_name_fr: 'nouveau shekel israélien',
        currency_name_plural_fr: 'nouveaux shekels israéliens',
        currency_code: 'ILS',
        currency_symbol_native: '₪',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 109,
        code: 380,
        alpha2: 'IT',
        alpha3: 'ITA',
        english_name: 'Italy',
        french_name: 'Italie',
        call_sign: 39,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 110,
        code: 384,
        alpha2: 'CI',
        alpha3: 'CIV',
        english_name: 'Côte d\'Ivoire',
        french_name: 'Côte d\'Ivoire',
        call_sign: 225,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 111,
        code: 388,
        alpha2: 'JM',
        alpha3: 'JAM',
        english_name: 'Jamaica',
        french_name: 'Jamaïque',
        call_sign: 876,
        currency_name_en: 'Jamaican Dollar',
        currency_name_fr: 'dollar jamaïcain',
        currency_name_plural_fr: 'dollars jamaïcains',
        currency_code: 'JMD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 112,
        code: 392,
        alpha2: 'JP',
        alpha3: 'JPN',
        english_name: 'Japan',
        french_name: 'Japon',
        call_sign: 81,
        currency_name_en: 'Japanese Yen',
        currency_name_fr: 'yen japonais',
        currency_name_plural_fr: 'yens japonais',
        currency_code: 'JPY',
        currency_symbol_native: '￥',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 113,
        code: 398,
        alpha2: 'KZ',
        alpha3: 'KAZ',
        english_name: 'Kazakhstan',
        french_name: 'Kazakhstan',
        call_sign: 7,
        currency_name_en: 'Tenge',
        currency_name_fr: 'tenge kazakh',
        currency_name_plural_fr: 'tenges kazakhs',
        currency_code: 'KZT',
        currency_symbol_native: '₸',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 114,
        code: 400,
        alpha2: 'JO',
        alpha3: 'JOR',
        english_name: 'Jordan',
        french_name: 'Jordanie',
        call_sign: 962,
        currency_name_en: 'Jordanian Dinar',
        currency_name_fr: 'dinar jordanien',
        currency_name_plural_fr: 'dinars jordaniens',
        currency_code: 'JOD',
        currency_symbol_native: 'د.أ.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 115,
        code: 404,
        alpha2: 'KE',
        alpha3: 'KEN',
        english_name: 'Kenya',
        french_name: 'Kenya',
        call_sign: 254,
        currency_name_en: 'Kenyan Shilling',
        currency_name_fr: 'shilling kényan',
        currency_name_plural_fr: 'shillings kényans',
        currency_code: 'KES',
        currency_symbol_native: 'Ksh',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 116,
        code: 408,
        alpha2: 'KP',
        alpha3: 'PRK',
        english_name: 'Democratic People\'s Republic of Korea',
        french_name: 'République Populaire Démocratique de Corée du Nord',
        call_sign: 850,
        currency_name_en: 'Won',
        currency_name_fr: 'won nord-coréen',
        currency_name_plural_fr: 'wons nord-coréens',
        currency_code: 'KPW',
        currency_symbol_native: 'KPW',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 117,
        code: 410,
        alpha2: 'KR',
        alpha3: 'KOR',
        english_name: 'Republic of Korea',
        french_name: 'République de Corée du Sud',
        call_sign: 82,
        currency_name_en: 'Won',
        currency_name_fr: 'won sud-coréen',
        currency_name_plural_fr: 'wons sud-coréens',
        currency_code: 'KRW',
        currency_symbol_native: '₩',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 118,
        code: 414,
        alpha2: 'KW',
        alpha3: 'KWT',
        english_name: 'Kuwait',
        french_name: 'Koweït',
        call_sign: 965,
        currency_name_en: 'Kuwaiti Dinar',
        currency_name_fr: 'dinar koweïtien',
        currency_name_plural_fr: 'dinar koweïtiens',
        currency_code: 'KWD',
        currency_symbol_native: 'د.ك.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 119,
        code: 417,
        alpha2: 'KG',
        alpha3: 'KGZ',
        english_name: 'Kyrgyzstan',
        french_name: 'Kirghizistan',
        call_sign: 996,
        currency_name_en: 'Som',
        currency_name_fr: 'som kirghize',
        currency_name_plural_fr: 'soms kirghizes',
        currency_code: 'KGS',
        currency_symbol_native: 'сом',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 120,
        code: 418,
        alpha2: 'LA',
        alpha3: 'LAO',
        english_name: 'Lao People\'s Democratic Republic',
        french_name: 'République Démocratique Populaire du Laos',
        call_sign: 856,
        currency_name_en: 'Kip',
        currency_name_fr: 'kip loatien',
        currency_name_plural_fr: 'kips loatiens',
        currency_code: 'LAK',
        currency_symbol_native: '₭',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 121,
        code: 422,
        alpha2: 'LB',
        alpha3: 'LBN',
        english_name: 'Lebanon',
        french_name: 'Liban',
        call_sign: 961,
        currency_name_en: 'Lebanese Pound',
        currency_name_fr: 'livre libanaise',
        currency_name_plural_fr: 'livres libanaises',
        currency_code: 'LBP',
        currency_symbol_native: 'ل.ل.‏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 122,
        code: 426,
        alpha2: 'LS',
        alpha3: 'LSO',
        english_name: 'Lesotho',
        french_name: 'Lesotho',
        call_sign: 266,
        currency_name_en: 'Loti',
        currency_name_fr: 'loti lesothan',
        currency_name_plural_fr: 'maloti lesothans',
        currency_code: 'LSL',
        currency_symbol_native: 'LSL',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 123,
        code: 428,
        alpha2: 'LV',
        alpha3: 'LVA',
        english_name: 'Latvia',
        french_name: 'Lettonie',
        call_sign: 371,
        currency_name_en: 'Lat',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'LVL',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 124,
        code: 430,
        alpha2: 'LR',
        alpha3: 'LBR',
        english_name: 'Liberia',
        french_name: 'Libéria',
        call_sign: 231,
        currency_name_en: 'Liberian Dollar',
        currency_name_fr: 'dollar libérien',
        currency_name_plural_fr: 'dollars libériens',
        currency_code: 'LRD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 125,
        code: 434,
        alpha2: 'LY',
        alpha3: 'LBY',
        english_name: 'Libyan Arab Jamahiriya',
        french_name: 'Libye',
        call_sign: 218,
        currency_name_en: 'Libyan Dinar',
        currency_name_fr: 'dinar libyen',
        currency_name_plural_fr: 'dinars libyens',
        currency_code: 'LYD',
        currency_symbol_native: 'د.ل.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 126,
        code: 438,
        alpha2: 'LI',
        alpha3: 'LIE',
        english_name: 'Liechtenstein',
        french_name: 'Liechtenstein',
        call_sign: 423,
        currency_name_en: 'Swiss Franc',
        currency_name_fr: 'franc suisse',
        currency_name_plural_fr: 'francs suisses',
        currency_code: 'CHF',
        currency_symbol_native: 'CHF',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 127,
        code: 440,
        alpha2: 'LT',
        alpha3: 'LTU',
        english_name: 'Lithuania',
        french_name: 'Lituanie',
        call_sign: 370,
        currency_name_en: 'Lita',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'LTL',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 128,
        code: 442,
        alpha2: 'LU',
        alpha3: 'LUX',
        english_name: 'Luxembourg',
        french_name: 'Luxembourg',
        call_sign: 352,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 129,
        code: 446,
        alpha2: 'MO',
        alpha3: 'MAC',
        english_name: 'Macao',
        french_name: 'Macao',
        call_sign: 853,
        currency_name_en: 'Pataca',
        currency_name_fr: 'pataca macanaise',
        currency_name_plural_fr: 'patacas macanaises',
        currency_code: 'MOP',
        currency_symbol_native: 'MOP$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 130,
        code: 450,
        alpha2: 'MG',
        alpha3: 'MDG',
        english_name: 'Madagascar',
        french_name: 'Madagascar',
        call_sign: 261,
        currency_name_en: 'Malagasy Franc',
        currency_name_fr: 'ariary malgache',
        currency_name_plural_fr: 'ariarys malgaches',
        currency_code: 'MGA',
        currency_symbol_native: 'Ar',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 131,
        code: 454,
        alpha2: 'MW',
        alpha3: 'MWI',
        english_name: 'Malawi',
        french_name: 'Malawi',
        call_sign: 265,
        currency_name_en: 'Malawian Kwacha',
        currency_name_fr: 'kwacha malawite',
        currency_name_plural_fr: 'kwachas malawites',
        currency_code: 'MWK',
        currency_symbol_native: 'MK',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 132,
        code: 458,
        alpha2: 'MY',
        alpha3: 'MYS',
        english_name: 'Malaysia',
        french_name: 'Malaisie',
        call_sign: 60,
        currency_name_en: 'Ringgit',
        currency_name_fr: 'ringgit malais',
        currency_name_plural_fr: 'ringgits malais',
        currency_code: 'MYR',
        currency_symbol_native: 'RM',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 133,
        code: 462,
        alpha2: 'MV',
        alpha3: 'MDV',
        english_name: 'Maldives',
        french_name: 'Maldives',
        call_sign: 960,
        currency_name_en: 'Rufiyaa',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'MVR',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 134,
        code: 466,
        alpha2: 'ML',
        alpha3: 'MLI',
        english_name: 'Mali',
        french_name: 'Mali',
        call_sign: 223,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 135,
        code: 470,
        alpha2: 'MT',
        alpha3: 'MLT',
        english_name: 'Malta',
        french_name: 'Malte',
        call_sign: 356,
        currency_name_en: 'Maltese Lira',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'MTL',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 136,
        code: 474,
        alpha2: 'MQ',
        alpha3: 'MTQ',
        english_name: 'Martinique',
        french_name: 'Martinique',
        call_sign: 596,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 137,
        code: 478,
        alpha2: 'MR',
        alpha3: 'MRT',
        english_name: 'Mauritania',
        french_name: 'Mauritanie',
        call_sign: 222,
        currency_name_en: 'Ouguiya',
        currency_name_fr: 'ouguiya mauritanien',
        currency_name_plural_fr: 'ouguiyas mauritaniens',
        currency_code: 'MRO',
        currency_symbol_native: 'أ.م.‏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 138,
        code: 480,
        alpha2: 'MU',
        alpha3: 'MUS',
        english_name: 'Mauritius',
        french_name: 'Maurice',
        call_sign: 230,
        currency_name_en: 'Mauritian Rupee',
        currency_name_fr: 'roupie mauricienne',
        currency_name_plural_fr: 'roupies mauriciennes',
        currency_code: 'MUR',
        currency_symbol_native: 'Rs',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 139,
        code: 484,
        alpha2: 'MX',
        alpha3: 'MEX',
        english_name: 'Mexico',
        french_name: 'Mexique',
        call_sign: 52,
        currency_name_en: 'Peso',
        currency_name_fr: 'peso mexicain',
        currency_name_plural_fr: 'pesos mexicains',
        currency_code: 'MXN',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 140,
        code: 492,
        alpha2: 'MC',
        alpha3: 'MCO',
        english_name: 'Monaco',
        french_name: 'Monaco',
        call_sign: 377,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 141,
        code: 496,
        alpha2: 'MN',
        alpha3: 'MNG',
        english_name: 'Mongolia',
        french_name: 'Mongolie',
        call_sign: 976,
        currency_name_en: 'Tugrik',
        currency_name_fr: 'tugrik mongol',
        currency_name_plural_fr: 'tugriks mongols',
        currency_code: 'MNT',
        currency_symbol_native: '₮',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 142,
        code: 498,
        alpha2: 'MD',
        alpha3: 'MDA',
        english_name: 'Republic of Moldova',
        french_name: 'République de Moldavie',
        call_sign: 373,
        currency_name_en: 'Leu',
        currency_name_fr: 'leu moldave',
        currency_name_plural_fr: 'leus moldaves',
        currency_code: 'MDL',
        currency_symbol_native: 'L',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 143,
        code: 499,
        alpha2: 'ME',
        alpha3: 'MNE',
        english_name: 'Montenegro',
        french_name: 'Monténégro',
        call_sign: 382,
        currency_name_en: 'Euro',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 144,
        code: 500,
        alpha2: 'MS',
        alpha3: 'MSR',
        english_name: 'Montserrat',
        french_name: 'Montserrat',
        call_sign: 1664,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 145,
        code: 504,
        alpha2: 'MA',
        alpha3: 'MAR',
        english_name: 'Morocco',
        french_name: 'Maroc',
        call_sign: 212,
        currency_name_en: 'Dirham',
        currency_name_fr: 'dirham marocain',
        currency_name_plural_fr: 'dirhams marocains',
        currency_code: 'MAD',
        currency_symbol_native: 'د.م.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 146,
        code: 508,
        alpha2: 'MZ',
        alpha3: 'MOZ',
        english_name: 'Mozambique',
        french_name: 'Mozambique',
        call_sign: 258,
        currency_name_en: 'Metical',
        currency_name_fr: 'metical mozambicain',
        currency_name_plural_fr: 'meticais mozambicains',
        currency_code: 'MZN',
        currency_symbol_native: 'MTn',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 147,
        code: 512,
        alpha2: 'OM',
        alpha3: 'OMN',
        english_name: 'Oman',
        french_name: 'Oman',
        call_sign: 968,
        currency_name_en: 'Sul Rial',
        currency_name_fr: 'riyal omanais',
        currency_name_plural_fr: 'riyals omanis',
        currency_code: 'OMR',
        currency_symbol_native: 'ر.ع.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 148,
        code: 516,
        alpha2: 'NA',
        alpha3: 'NAM',
        english_name: 'Namibia',
        french_name: 'Namibie',
        call_sign: 264,
        currency_name_en: 'Dollar',
        currency_name_fr: 'dollar namibien',
        currency_name_plural_fr: 'dollars namibiens',
        currency_code: 'NAD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 149,
        code: 520,
        alpha2: 'NR',
        alpha3: 'NRU',
        english_name: 'Nauru',
        french_name: 'Nauru',
        call_sign: 674,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 150,
        code: 524,
        alpha2: 'NP',
        alpha3: 'NPL',
        english_name: 'Nepal',
        french_name: 'Népal',
        call_sign: 977,
        currency_name_en: 'Nepalese Rupee',
        currency_name_fr: 'roupie népalaise',
        currency_name_plural_fr: 'roupies népalaises',
        currency_code: 'NPR',
        currency_symbol_native: 'नेरू',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 151,
        code: 528,
        alpha2: 'NL',
        alpha3: 'NLD',
        english_name: 'Netherlands',
        french_name: 'Pays-Bas',
        call_sign: 31,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 152,
        code: 531,
        alpha2: 'CW',
        alpha3: 'CUW',
        english_name: 'Curaçao',
        french_name: 'Curaçao',
        call_sign: 599,
        currency_name_en: 'Netherlands Antillean guilder',
        currency_name_fr: 'florin antillais',
        currency_name_plural_fr: 'florins antillais',
        currency_code: 'ANG',
        currency_symbol_native: 'NAf.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 153,
        code: 533,
        alpha2: 'AW',
        alpha3: 'ABW',
        english_name: 'Aruba',
        french_name: 'Aruba',
        call_sign: 297,
        currency_name_en: 'Aruban florin',
        currency_name_fr: 'florin arubais',
        currency_name_plural_fr: 'florins arubais',
        currency_code: 'AWG',
        currency_symbol_native: 'Afl.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 154,
        code: 534,
        alpha2: 'SX',
        alpha3: 'SXM',
        english_name: 'Sint Maarten (Dutch part)',
        french_name: 'Saint-Martin (partie néerlandaise)',
        call_sign: 599,
        currency_name_en: 'Netherlands Antillean guilder',
        currency_name_fr: 'florin antillais',
        currency_name_plural_fr: 'florins antillais',
        currency_code: 'ANG',
        currency_symbol_native: 'NAf.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 155,
        code: 535,
        alpha2: 'BQ',
        alpha3: 'BES',
        english_name: 'Bonaire, Sint Eustatius and Saba',
        french_name: 'Bonaire, Saint-Eustache et Saba',
        call_sign: 599,
        currency_name_en: 'Netherlands Antillean guilder',
        currency_name_fr: 'florin antillais',
        currency_name_plural_fr: 'florins antillais',
        currency_code: 'ANG',
        currency_symbol_native: 'NAf.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 156,
        code: 540,
        alpha2: 'NC',
        alpha3: 'NCL',
        english_name: 'New Caledonia',
        french_name: 'Nouvelle-Calédonie',
        call_sign: 687,
        currency_name_en: 'CFP Franc',
        currency_name_fr: 'franc CFP',
        currency_name_plural_fr: 'francs CFP',
        currency_code: 'XPF',
        currency_symbol_native: 'FCFP',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 157,
        code: 548,
        alpha2: 'VU',
        alpha3: 'VUT',
        english_name: 'Vanuatu',
        french_name: 'Vanuatu',
        call_sign: 678,
        currency_name_en: 'Vatu',
        currency_name_fr: 'vatu vanuatuan',
        currency_name_plural_fr: 'vatus vanuatuans',
        currency_code: 'VUV',
        currency_symbol_native: 'VT',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 158,
        code: 554,
        alpha2: 'NZ',
        alpha3: 'NZL',
        english_name: 'New Zealand',
        french_name: 'Nouvelle-Zélande',
        call_sign: 64,
        currency_name_en: 'New Zealand Dollars',
        currency_name_fr: 'dollar néo-zélandais',
        currency_name_plural_fr: 'dollars néo-zélandais',
        currency_code: 'NZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 159,
        code: 558,
        alpha2: 'NI',
        alpha3: 'NIC',
        english_name: 'Nicaragua',
        french_name: 'Nicaragua',
        call_sign: 505,
        currency_name_en: 'Cordoba Oro',
        currency_name_fr: 'córdoba oro nicaraguayen',
        currency_name_plural_fr: 'córdobas oro nicaraguayens',
        currency_code: 'NIO',
        currency_symbol_native: 'C$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 160,
        code: 562,
        alpha2: 'NE',
        alpha3: 'NER',
        english_name: 'Niger',
        french_name: 'Niger',
        call_sign: 227,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 161,
        code: 566,
        alpha2: 'NG',
        alpha3: 'NGA',
        english_name: 'Nigeria',
        french_name: 'Nigéria',
        call_sign: 234,
        currency_name_en: 'Naira',
        currency_name_fr: 'naira nigérian',
        currency_name_plural_fr: 'nairas nigérians',
        currency_code: 'NGN',
        currency_symbol_native: '₦',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 162,
        code: 570,
        alpha2: 'NU',
        alpha3: 'NIU',
        english_name: 'Niue',
        french_name: 'Niué',
        call_sign: 683,
        currency_name_en: 'New Zealand Dollars',
        currency_name_fr: 'dollar néo-zélandais',
        currency_name_plural_fr: 'dollars néo-zélandais',
        currency_code: 'NZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 163,
        code: 574,
        alpha2: 'NF',
        alpha3: 'NFK',
        english_name: 'Norfolk Island',
        french_name: 'Île Norfolk',
        call_sign: 6723,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 164,
        code: 578,
        alpha2: 'NO',
        alpha3: 'NOR',
        english_name: 'Norway',
        french_name: 'Norvège',
        call_sign: 47,
        currency_name_en: 'Norwegian Krone',
        currency_name_fr: 'couronne norvégienne',
        currency_name_plural_fr: 'couronnes norvégiennes',
        currency_code: 'NOK',
        currency_symbol_native: 'kr',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 165,
        code: 580,
        alpha2: 'MP',
        alpha3: 'MNP',
        english_name: 'Northern Mariana Islands',
        french_name: 'Îles Mariannes du Nord',
        call_sign: 1670,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 166,
        code: 581,
        alpha2: 'UM',
        alpha3: 'UMI',
        english_name: 'United States Minor Outlying Islands',
        french_name: 'Îles Mineures Éloignées des États-Unis',
        call_sign: 246,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 167,
        code: 583,
        alpha2: 'FM',
        alpha3: 'FSM',
        english_name: 'Federated States of Micronesia',
        french_name: 'États Fédérés de Micronésie',
        call_sign: 691,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 168,
        code: 584,
        alpha2: 'MH',
        alpha3: 'MHL',
        english_name: 'Marshall Islands',
        french_name: 'Îles Marshall',
        call_sign: 692,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 169,
        code: 585,
        alpha2: 'PW',
        alpha3: 'PLW',
        english_name: 'Palau',
        french_name: 'Palaos',
        call_sign: 680,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 170,
        code: 586,
        alpha2: 'PK',
        alpha3: 'PAK',
        english_name: 'Pakistan',
        french_name: 'Pakistan',
        call_sign: 92,
        currency_name_en: 'Rupee',
        currency_name_fr: 'roupie pakistanaise',
        currency_name_plural_fr: 'roupies pakistanaises',
        currency_code: 'PKR',
        currency_symbol_native: 'Rs',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 171,
        code: 591,
        alpha2: 'PA',
        alpha3: 'PAN',
        english_name: 'Panama',
        french_name: 'Panama',
        call_sign: 507,
        currency_name_en: 'Balboa',
        currency_name_fr: 'balboa panaméen',
        currency_name_plural_fr: 'balboas panaméens',
        currency_code: 'PAB',
        currency_symbol_native: 'B/.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 172,
        code: 598,
        alpha2: 'PG',
        alpha3: 'PNG',
        english_name: 'Papua New Guinea',
        french_name: 'Papouasie-Nouvelle-Guinée',
        call_sign: 675,
        currency_name_en: 'Kina',
        currency_name_fr: 'kina papouan-néo-guinéen',
        currency_name_plural_fr: 'kinas papouan-néo-guinéens',
        currency_code: 'PGK',
        currency_symbol_native: 'K',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 173,
        code: 600,
        alpha2: 'PY',
        alpha3: 'PRY',
        english_name: 'Paraguay',
        french_name: 'Paraguay',
        call_sign: 595,
        currency_name_en: 'Guarani',
        currency_name_fr: 'guaraní paraguayen',
        currency_name_plural_fr: 'guaranís paraguayens',
        currency_code: 'PYG',
        currency_symbol_native: 'Gs.',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 174,
        code: 604,
        alpha2: 'PE',
        alpha3: 'PER',
        english_name: 'Peru',
        french_name: 'Pérou',
        call_sign: 51,
        currency_name_en: 'Nuevo Sol',
        currency_name_fr: 'sol péruvien',
        currency_name_plural_fr: 'sols péruviens',
        currency_code: 'PEN',
        currency_symbol_native: 'S/',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 175,
        code: 608,
        alpha2: 'PH',
        alpha3: 'PHL',
        english_name: 'Philippines',
        french_name: 'Philippines',
        call_sign: 63,
        currency_name_en: 'Peso',
        currency_name_fr: 'peso philippin',
        currency_name_plural_fr: 'pesos philippins',
        currency_code: 'PHP',
        currency_symbol_native: '₱',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 176,
        code: 612,
        alpha2: 'PN',
        alpha3: 'PCN',
        english_name: 'Pitcairn',
        french_name: 'Pitcairn',
        call_sign: 64,
        currency_name_en: 'New Zealand Dollars',
        currency_name_fr: 'dollar néo-zélandais',
        currency_name_plural_fr: 'dollars néo-zélandais',
        currency_code: 'NZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 177,
        code: 616,
        alpha2: 'PL',
        alpha3: 'POL',
        english_name: 'Poland',
        french_name: 'Pologne',
        call_sign: 48,
        currency_name_en: 'Zloty',
        currency_name_fr: 'zloty polonais',
        currency_name_plural_fr: 'zlotys polonais',
        currency_code: 'PLN',
        currency_symbol_native: 'zł',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 178,
        code: 620,
        alpha2: 'PT',
        alpha3: 'PRT',
        english_name: 'Portugal',
        french_name: 'Portugal',
        call_sign: 351,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 179,
        code: 624,
        alpha2: 'GW',
        alpha3: 'GNB',
        english_name: 'Guinea-Bissau',
        french_name: 'Guinée-Bissau',
        call_sign: 245,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 180,
        code: 626,
        alpha2: 'TL',
        alpha3: 'TLS',
        english_name: 'Timor-Leste',
        french_name: 'Timor-Leste',
        call_sign: 670,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    /*
    {
        id: 181,
        code: 630,
        alpha2: 'PR',
        alpha3: 'PRI',
        english_name: 'Puerto Rico',
        french_name: 'Porto Rico',
        call_sign: 1,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },*/
    {
        id: 182,
        code: 634,
        alpha2: 'QA',
        alpha3: 'QAT',
        english_name: 'Qatar',
        french_name: 'Qatar',
        call_sign: 974,
        currency_name_en: 'Rial',
        currency_name_fr: 'riyal qatari',
        currency_name_plural_fr: 'riyals qataris',
        currency_code: 'QAR',
        currency_symbol_native: 'ر.ق.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 183,
        code: 638,
        alpha2: 'RE',
        alpha3: 'REU',
        english_name: 'Réunion',
        french_name: 'Réunion',
        call_sign: 262,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 184,
        code: 642,
        alpha2: 'RO',
        alpha3: 'ROU',
        english_name: 'Romania',
        french_name: 'Roumanie',
        call_sign: 40,
        currency_name_en: 'Leu',
        currency_name_fr: 'leu roumain',
        currency_name_plural_fr: 'lei roumains',
        currency_code: 'RON',
        currency_symbol_native: 'RON',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 185,
        code: 643,
        alpha2: 'RU',
        alpha3: 'RUS',
        english_name: 'Russian Federation',
        french_name: 'Fédération de Russie',
        call_sign: 7,
        currency_name_en: 'Ruble',
        currency_name_fr: 'rouble russe',
        currency_name_plural_fr: 'roubles russes',
        currency_code: 'RUB',
        currency_symbol_native: '₽',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 186,
        code: 646,
        alpha2: 'RW',
        alpha3: 'RWA',
        english_name: 'Rwanda',
        french_name: 'Rwanda',
        call_sign: 250,
        currency_name_en: 'Rwanda Franc',
        currency_name_fr: 'franc rwandais',
        currency_name_plural_fr: 'francs rwandais',
        currency_code: 'RWF',
        currency_symbol_native: 'RF',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 187,
        code: 652,
        alpha2: 'BL',
        alpha3: 'BLM',
        english_name: 'Saint Barthélemy',
        french_name: 'Saint Barthélemy',
        call_sign: 590,
        currency_name_en: 'Euro',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 188,
        code: 654,
        alpha2: 'SH',
        alpha3: 'SHN',
        english_name: 'Saint Helena',
        french_name: 'Sainte-Hélène',
        call_sign: 290,
        currency_name_en: 'Saint Helena pound',
        currency_name_fr: 'livre sterling',
        currency_name_plural_fr: 'livres sterling',
        currency_code: 'GBP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 189,
        code: 659,
        alpha2: 'KN',
        alpha3: 'KNA',
        english_name: 'Saint Kitts and Nevis',
        french_name: 'Saint-Kitts-et-Nevis',
        call_sign: 869,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 190,
        code: 660,
        alpha2: 'AI',
        alpha3: 'AIA',
        english_name: 'Anguilla',
        french_name: 'Anguilla',
        call_sign: 1264,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 191,
        code: 662,
        alpha2: 'LC',
        alpha3: 'LCA',
        english_name: 'Saint Lucia',
        french_name: 'Sainte-Lucie',
        call_sign: 758,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 192,
        code: 663,
        alpha2: 'MF',
        alpha3: 'MAF',
        english_name: 'Saint Martin (French part)',
        french_name: 'Saint-Martin (partie française)',
        call_sign: 590,
        currency_name_en: 'Euro',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 193,
        code: 666,
        alpha2: 'PM',
        alpha3: 'SPM',
        english_name: 'Saint-Pierre and Miquelon',
        french_name: 'Saint-Pierre-et-Miquelon',
        call_sign: 508,
        currency_name_en: 'Euro',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 194,
        code: 670,
        alpha2: 'VC',
        alpha3: 'VCT',
        english_name: 'Saint Vincent and the Grenadines',
        french_name: 'Saint-Vincent-et-les Grenadines',
        call_sign: 784,
        currency_name_en: 'East Caribbean Dollar',
        currency_name_fr: 'dollar des Caraïbes orientales',
        currency_name_plural_fr: 'dollars des Caraïbes orientales',
        currency_code: 'XCD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 195,
        code: 674,
        alpha2: 'SM',
        alpha3: 'SMR',
        english_name: 'San Marino',
        french_name: 'Saint-Marin',
        call_sign: 378,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 196,
        code: 678,
        alpha2: 'ST',
        alpha3: 'STP',
        english_name: 'Sao Tome and Principe',
        french_name: 'Sao Tomé-et-Principe',
        call_sign: 239,
        currency_name_en: 'Dobra',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'STD',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 197,
        code: 682,
        alpha2: 'SA',
        alpha3: 'SAU',
        english_name: 'Saudi Arabia',
        french_name: 'Arabie Saoudite',
        call_sign: 966,
        currency_name_en: 'Riyal',
        currency_name_fr: 'riyal saoudien',
        currency_name_plural_fr: 'riyals saoudiens',
        currency_code: 'SAR',
        currency_symbol_native: 'ر.س.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 198,
        code: 686,
        alpha2: 'SN',
        alpha3: 'SEN',
        english_name: 'Senegal',
        french_name: 'Sénégal',
        call_sign: 221,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 199,
        code: 688,
        alpha2: 'RS',
        alpha3: 'SRB',
        english_name: 'Serbia',
        french_name: 'Serbie',
        call_sign: 381,
        currency_name_en: 'Serbian dinar',
        currency_name_fr: 'dinar serbe',
        currency_name_plural_fr: 'dinars serbes',
        currency_code: 'RSD',
        currency_symbol_native: 'RSD',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 200,
        code: 690,
        alpha2: 'SC',
        alpha3: 'SYC',
        english_name: 'Seychelles',
        french_name: 'Seychelles',
        call_sign: 248,
        currency_name_en: 'Rupee',
        currency_name_fr: 'roupie des Seychelles',
        currency_name_plural_fr: 'roupies des Seychelles',
        currency_code: 'SCR',
        currency_symbol_native: 'SR',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 201,
        code: 694,
        alpha2: 'SL',
        alpha3: 'SLE',
        english_name: 'Sierra Leone',
        french_name: 'Sierra Leone',
        call_sign: 232,
        currency_name_en: 'Leone',
        currency_name_fr: 'leone sierra-léonais',
        currency_name_plural_fr: 'leones sierra-léonais',
        currency_code: 'SLL',
        currency_symbol_native: 'Le',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 202,
        code: 702,
        alpha2: 'SG',
        alpha3: 'SGP',
        english_name: 'Singapore',
        french_name: 'Singapour',
        call_sign: 65,
        currency_name_en: 'Dollar',
        currency_name_fr: 'dollar de Singapour',
        currency_name_plural_fr: 'dollars de Singapour',
        currency_code: 'SGD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 203,
        code: 703,
        alpha2: 'SK',
        alpha3: 'SVK',
        english_name: 'Slovakia',
        french_name: 'Slovaquie',
        call_sign: 421,
        currency_name_en: 'Koruna',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'SKK',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 204,
        code: 704,
        alpha2: 'VN',
        alpha3: 'VNM',
        english_name: 'Vietnam',
        french_name: 'Viet Nam',
        call_sign: 84,
        currency_name_en: 'Dong',
        currency_name_fr: 'dông vietnamien',
        currency_name_plural_fr: 'dôngs vietnamiens',
        currency_code: 'VND',
        currency_symbol_native: '₫',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 205,
        code: 705,
        alpha2: 'SI',
        alpha3: 'SVN',
        english_name: 'Slovenia',
        french_name: 'Slovénie',
        call_sign: 386,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 206,
        code: 706,
        alpha2: 'SO',
        alpha3: 'SOM',
        english_name: 'Somalia',
        french_name: 'Somalie',
        call_sign: 252,
        currency_name_en: 'Shilling',
        currency_name_fr: 'shilling somalien',
        currency_name_plural_fr: 'shillings somaliens',
        currency_code: 'SOS',
        currency_symbol_native: 'S',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 207,
        code: 710,
        alpha2: 'ZA',
        alpha3: 'ZAF',
        english_name: 'South Africa',
        french_name: 'Afrique du Sud',
        call_sign: 27,
        currency_name_en: 'Rand',
        currency_name_fr: 'rand sud-africain',
        currency_name_plural_fr: 'rands sud-africains',
        currency_code: 'ZAR',
        currency_symbol_native: 'R',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 208,
        code: 716,
        alpha2: 'ZW',
        alpha3: 'ZWE',
        english_name: 'Zimbabwe',
        french_name: 'Zimbabwe',
        call_sign: 263,
        currency_name_en: 'Zimbabwe Dollar',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'ZWD',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 209,
        code: 724,
        alpha2: 'ES',
        alpha3: 'ESP',
        english_name: 'Spain',
        french_name: 'Espagne',
        call_sign: 34,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 210,
        code: 728,
        alpha2: 'SS',
        alpha3: 'SSD',
        english_name: 'South Sudan',
        french_name: 'Soudan du Sud',
        call_sign: 211,
        currency_name_en: 'South Sudanese pound',
        currency_name_fr: 'livre sud-soudanaise',
        currency_name_plural_fr: 'livres sud-soudanaises',
        currency_code: 'SSP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 211,
        code: 729,
        alpha2: 'SD',
        alpha3: 'SDN',
        english_name: 'Sudan',
        french_name: 'Soudan',
        call_sign: 249,
        currency_name_en: 'Dinar',
        currency_name_fr: 'livre soudanaise',
        currency_name_plural_fr: 'livres soudanaises',
        currency_code: 'SDG',
        currency_symbol_native: 'ج.س.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    /*
    {
        id: 212,
        code: 732,
        alpha2: 'EH',
        alpha3: 'ESH',
        english_name: 'Western Sahara',
        french_name: 'Sahara Occidental',
        call_sign: 212,
        currency_name_en: 'Dirham',
        currency_name_fr: 'dirham marocain',
        currency_name_plural_fr: 'dirhams marocains',
        currency_code: 'MAD',
        currency_symbol_native: 'د.م.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    }, */
    {
        id: 213,
        code: 740,
        alpha2: 'SR',
        alpha3: 'SUR',
        english_name: 'Suriname',
        french_name: 'Suriname',
        call_sign: 597,
        currency_name_en: 'Surinamese Guilder',
        currency_name_fr: 'dollar surinamais',
        currency_name_plural_fr: 'dollars surinamais',
        currency_code: 'SRD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 214,
        code: 744,
        alpha2: 'SJ',
        alpha3: 'SJM',
        english_name: 'Svalbard and Jan Mayen',
        french_name: 'Svalbard et Île Jan Mayen',
        call_sign: 47,
        currency_name_en: 'Norwegian Krone',
        currency_name_fr: 'couronne norvégienne',
        currency_name_plural_fr: 'couronnes norvégiennes',
        currency_code: 'NOK',
        currency_symbol_native: 'kr',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 215,
        code: 748,
        alpha2: 'SZ',
        alpha3: 'SWZ',
        english_name: 'Swaziland',
        french_name: 'Swaziland',
        call_sign: 268,
        currency_name_en: 'Lilangeni',
        currency_name_fr: 'lilangeni swazi',
        currency_name_plural_fr: 'lilangenis swazis',
        currency_code: 'SZL',
        currency_symbol_native: 'E',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 216,
        code: 752,
        alpha2: 'SE',
        alpha3: 'SWE',
        english_name: 'Sweden',
        french_name: 'Suède',
        call_sign: 46,
        currency_name_en: 'Krona',
        currency_name_fr: 'couronne suédoise',
        currency_name_plural_fr: 'couronnes suédoises',
        currency_code: 'SEK',
        currency_symbol_native: 'kr',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 217,
        code: 756,
        alpha2: 'CH',
        alpha3: 'CHE',
        english_name: 'Switzerland',
        french_name: 'Suisse',
        call_sign: 41,
        currency_name_en: 'Swiss Franc',
        currency_name_fr: 'franc suisse',
        currency_name_plural_fr: 'francs suisses',
        currency_code: 'CHF',
        currency_symbol_native: 'CHF',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 218,
        code: 760,
        alpha2: 'SY',
        alpha3: 'SYR',
        english_name: 'Syrian Arab Republic',
        french_name: 'République Arabe Syrienne',
        call_sign: 963,
        currency_name_en: 'Syrian Pound',
        currency_name_fr: 'livre syrienne',
        currency_name_plural_fr: 'livres syriennes',
        currency_code: 'SYP',
        currency_symbol_native: 'ل.س.‏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 219,
        code: 762,
        alpha2: 'TJ',
        alpha3: 'TJK',
        english_name: 'Tajikistan',
        french_name: 'Tadjikistan',
        call_sign: 992,
        currency_name_en: 'Tajikistan Ruble',
        currency_name_fr: 'somoni tadjik',
        currency_name_plural_fr: 'somonis tadjiks',
        currency_code: 'TJS',
        currency_symbol_native: 'сом.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 220,
        code: 764,
        alpha2: 'TH',
        alpha3: 'THA',
        english_name: 'Thailand',
        french_name: 'Thaïlande',
        call_sign: 66,
        currency_name_en: 'Baht',
        currency_name_fr: 'baht thaïlandais',
        currency_name_plural_fr: 'bahts thaïlandais',
        currency_code: 'THB',
        currency_symbol_native: 'THB',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 221,
        code: 768,
        alpha2: 'TG',
        alpha3: 'TGO',
        english_name: 'Togo',
        french_name: 'Togo',
        call_sign: 228,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 222,
        code: 772,
        alpha2: 'TK',
        alpha3: 'TKL',
        english_name: 'Tokelau',
        french_name: 'Tokelau',
        call_sign: 690,
        currency_name_en: 'New Zealand Dollars',
        currency_name_fr: 'dollar néo-zélandais',
        currency_name_plural_fr: 'dollars néo-zélandais',
        currency_code: 'NZD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 223,
        code: 776,
        alpha2: 'TO',
        alpha3: 'TON',
        english_name: 'Tonga',
        french_name: 'Tonga',
        call_sign: 676,
        currency_name_en: 'Pa√ïanga',
        currency_name_fr: 'pa’anga tongan',
        currency_name_plural_fr: 'pa’angas tongans',
        currency_code: 'TOP',
        currency_symbol_native: 'T$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 224,
        code: 780,
        alpha2: 'TT',
        alpha3: 'TTO',
        english_name: 'Trinidad and Tobago',
        french_name: 'Trinité-et-Tobago',
        call_sign: 1868,
        currency_name_en: 'Trinidad and Tobago Dollar',
        currency_name_fr: 'dollar trinidadien',
        currency_name_plural_fr: 'dollars de Trinité-et-Tobago',
        currency_code: 'TTD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 225,
        code: 784,
        alpha2: 'AE',
        alpha3: 'ARE',
        english_name: 'United Arab Emirates',
        french_name: 'Émirats Arabes Unis',
        call_sign: 971,
        currency_name_en: 'Dirham',
        currency_name_fr: 'dirham des Émirats arabes unis',
        currency_name_plural_fr: 'dirhams des Émirats arabes unis',
        currency_code: 'AED',
        currency_symbol_native: 'د.إ.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 226,
        code: 788,
        alpha2: 'TN',
        alpha3: 'TUN',
        english_name: 'Tunisia',
        french_name: 'Tunisie',
        call_sign: 216,
        currency_name_en: 'Tunisian Dinar',
        currency_name_fr: 'dinar tunisien',
        currency_name_plural_fr: 'dinars tunisiens',
        currency_code: 'TND',
        currency_symbol_native: 'د.ت.‏',
        currency_decimal_digits: 3,
        currency_rounding: 0
    },
    {
        id: 227,
        code: 792,
        alpha2: 'TR',
        alpha3: 'TUR',
        english_name: 'Turkey',
        french_name: 'Turquie',
        call_sign: 90,
        currency_name_en: 'Lira',
        currency_name_fr: 'livre turque',
        currency_name_plural_fr: 'livres turques',
        currency_code: 'TRY',
        currency_symbol_native: '₺',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 228,
        code: 795,
        alpha2: 'TM',
        alpha3: 'TKM',
        english_name: 'Turkmenistan',
        french_name: 'Turkménistan',
        call_sign: 993,
        currency_name_en: 'Manat',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'TMT',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 229,
        code: 796,
        alpha2: 'TC',
        alpha3: 'TCA',
        english_name: 'Turks and Caicos Islands',
        french_name: 'Îles Turks et Caïques',
        call_sign: 1649,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 230,
        code: 798,
        alpha2: 'TV',
        alpha3: 'TUV',
        english_name: 'Tuvalu',
        french_name: 'Tuvalu',
        call_sign: 688,
        currency_name_en: 'Australian Dollars',
        currency_name_fr: 'dollar australien',
        currency_name_plural_fr: 'dollars australiens',
        currency_code: 'AUD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 231,
        code: 800,
        alpha2: 'UG',
        alpha3: 'UGA',
        english_name: 'Uganda',
        french_name: 'Ouganda',
        call_sign: 256,
        currency_name_en: 'Shilling',
        currency_name_fr: 'shilling ougandais',
        currency_name_plural_fr: 'shillings ougandais',
        currency_code: 'UGX',
        currency_symbol_native: 'USh',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 232,
        code: 804,
        alpha2: 'UA',
        alpha3: 'UKR',
        english_name: 'Ukraine',
        french_name: 'Ukraine',
        call_sign: 380,
        currency_name_en: 'Hryvnia',
        currency_name_fr: 'hryvnia ukrainienne',
        currency_name_plural_fr: 'hryvnias ukrainiennes',
        currency_code: 'UAH',
        currency_symbol_native: '₴',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 233,
        code: 807,
        alpha2: 'MK',
        alpha3: 'MKD',
        english_name: 'The Former Yugoslav Republic of Macedonia',
        french_name: 'L\'ex-République Yougoslave de Macédoine',
        call_sign: 38,
        currency_name_en: 'Denar',
        currency_name_fr: 'denar macédonien',
        currency_name_plural_fr: 'denars macédoniens',
        currency_code: 'MKD',
        currency_symbol_native: 'ден',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 234,
        code: 818,
        alpha2: 'EG',
        alpha3: 'EGY',
        english_name: 'Egypt',
        french_name: 'Égypte',
        call_sign: 20,
        currency_name_en: 'Egyptian Pound',
        currency_name_fr: 'livre égyptienne',
        currency_name_plural_fr: 'livres égyptiennes',
        currency_code: 'EGP',
        currency_symbol_native: 'ج.م.‏',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 235,
        code: 826,
        alpha2: 'GB',
        alpha3: 'GBR',
        english_name: 'United Kingdom',
        french_name: 'Royaume-Uni',
        call_sign: 44,
        currency_name_en: 'Sterling',
        currency_name_fr: 'livre sterling',
        currency_name_plural_fr: 'livres sterling',
        currency_code: 'GBP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 236,
        code: 831,
        alpha2: 'GG',
        alpha3: 'GGY',
        english_name: 'Guernsey',
        french_name: 'Guernesey',
        call_sign: 44,
        currency_name_en: 'Guernsey pound',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'GGP',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    },
    {
        id: 237,
        code: 832,
        alpha2: 'JE',
        alpha3: 'JEY',
        english_name: 'Jersey',
        french_name: 'Jersey',
        call_sign: 44,
        currency_name_en: 'Sterling',
        currency_name_fr: 'livre sterling',
        currency_name_plural_fr: 'livres sterling',
        currency_code: 'GBP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 238,
        code: 833,
        alpha2: 'IM',
        alpha3: 'IMN',
        english_name: 'Isle of Man',
        french_name: 'Île de Man',
        call_sign: 44,
        currency_name_en: 'Manx pound',
        currency_name_fr: 'livre sterling',
        currency_name_plural_fr: 'livres sterling',
        currency_code: 'GBP',
        currency_symbol_native: '£',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 239,
        code: 834,
        alpha2: 'TZ',
        alpha3: 'TZA',
        english_name: 'United Republic Of Tanzania',
        french_name: 'République-Unie de Tanzanie',
        call_sign: 255,
        currency_name_en: 'Shilling',
        currency_name_fr: 'shilling tanzanien',
        currency_name_plural_fr: 'shillings tanzaniens',
        currency_code: 'TZS',
        currency_symbol_native: 'TSh',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    /*
    {
        id: 240,
        code: 840,
        alpha2: 'US',
        alpha3: 'USA',
        english_name: 'United States',
        french_name: 'États-Unis',
        call_sign: 1,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    }, */
    {
        id: 241,
        code: 850,
        alpha2: 'VI',
        alpha3: 'VIR',
        english_name: 'U.S. Virgin Islands',
        french_name: 'Îles Vierges des États-Unis',
        call_sign: 1340,
        currency_name_en: 'USD',
        currency_name_fr: 'dollar des États-Unis',
        currency_name_plural_fr: 'dollars des États-Unis',
        currency_code: 'USD',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 242,
        code: 854,
        alpha2: 'BF',
        alpha3: 'BFA',
        english_name: 'Burkina Faso',
        french_name: 'Burkina Faso',
        call_sign: 226,
        currency_name_en: 'CFA Franc BCEAO',
        currency_name_fr: 'franc CFA (BCEAO)',
        currency_name_plural_fr: 'francs CFA (BCEAO)',
        currency_code: 'XOF',
        currency_symbol_native: 'CFA',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 243,
        code: 858,
        alpha2: 'UY',
        alpha3: 'URY',
        english_name: 'Uruguay',
        french_name: 'Uruguay',
        call_sign: 598,
        currency_name_en: 'Peso',
        currency_name_fr: 'peso uruguayen',
        currency_name_plural_fr: 'pesos uruguayens',
        currency_code: 'UYU',
        currency_symbol_native: '$',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 244,
        code: 860,
        alpha2: 'UZ',
        alpha3: 'UZB',
        english_name: 'Uzbekistan',
        french_name: 'Ouzbékistan',
        call_sign: 998,
        currency_name_en: 'Som',
        currency_name_fr: 'sum ouzbek',
        currency_name_plural_fr: 'sums ouzbeks',
        currency_code: 'UZS',
        currency_symbol_native: 'сўм',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 245,
        code: 862,
        alpha2: 'VE',
        alpha3: 'VEN',
        english_name: 'Venezuela',
        french_name: 'Venezuela',
        call_sign: 58,
        currency_name_en: 'Bolivar',
        currency_name_fr: 'bolivar vénézuélien',
        currency_name_plural_fr: 'bolivars vénézuéliens',
        currency_code: 'VEF',
        currency_symbol_native: 'Bs.',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 246,
        code: 876,
        alpha2: 'WF',
        alpha3: 'WLF',
        english_name: 'Wallis and Futuna',
        french_name: 'Wallis et Futuna',
        call_sign: 681,
        currency_name_en: 'CFP Franc',
        currency_name_fr: 'franc CFP',
        currency_name_plural_fr: 'francs CFP',
        currency_code: 'XPF',
        currency_symbol_native: 'FCFP',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 247,
        code: 882,
        alpha2: 'WS',
        alpha3: 'WSM',
        english_name: 'Samoa',
        french_name: 'Samoa',
        call_sign: 685,
        currency_name_en: 'Euros',
        currency_name_fr: 'euro',
        currency_name_plural_fr: 'euros',
        currency_code: 'EUR',
        currency_symbol_native: '€',
        currency_decimal_digits: 2,
        currency_rounding: 0
    },
    {
        id: 248,
        code: 887,
        alpha2: 'YE',
        alpha3: 'YEM',
        english_name: 'Yemen',
        french_name: 'Yémen',
        call_sign: 967,
        currency_name_en: 'Rial',
        currency_name_fr: 'riyal yéménite',
        currency_name_plural_fr: 'riyals yéménites',
        currency_code: 'YER',
        currency_symbol_native: 'ر.ي.‏',
        currency_decimal_digits: 0,
        currency_rounding: 0
    },
    {
        id: 249,
        code: 894,
        alpha2: 'ZM',
        alpha3: 'ZMB',
        english_name: 'Zambia',
        french_name: 'Zambie',
        call_sign: 260,
        currency_name_en: 'Kwacha',
        currency_name_fr: '',
        currency_name_plural_fr: '',
        currency_code: 'ZMK',
        currency_symbol_native: '',
        currency_decimal_digits: null,
        currency_rounding: null
    }
];

export interface CountryInfosAndCurrencyModel {
    id: number;
    code: number;
    alpha2: string;
    alpha3: string;
    english_name: string;
    french_name: string;
    call_sign: number;
    currency_name_en: string;
    currency_name_fr: string;
    currency_name_plural_fr: string;
    currency_code: string;
    currency_symbol_native: string;
    currency_decimal_digits: number;
    currency_rounding: number;
}

